import type {SearchCriteriaRaw} from '../../../types';
import {createMetadataRule} from '../metadataRule';
import type {MetadataRule, TSearchTypeMetadata} from '../types';

export type RawMetadataSearchCriteria = SearchCriteriaRaw<TSearchTypeMetadata>;

export const rawMetadataCriteriaToRuleObject = (
	criteria: RawMetadataSearchCriteria,
): MetadataRule<any> => {
	return createMetadataRule({
		type: criteria.subtype1,
		name: criteria.value2,
		value: criteria.value1,
		rangeStart: criteria.value1,
		rangeEnd: criteria.value3,
	} as any);
};

export default rawMetadataCriteriaToRuleObject;
